
export const restaurantList = [
    // {
    //     "lat": "35.5540228645787",
    //     "lng": "129.309926751523",
    //     "title": "신천지대반점",
    //     "addr1": "울산 중구 당산4길 11",
    //     "addr2": "",
    //     "sidx": "5208",
    //     "thumb": "/upload/category/20241114165341_fcf231da.png",
    //     "smidx": "11",
    //     "category": "성시경 먹을텐데",
    //     "menu": "삼선우동, 야끼우동, 야끼짬뽕,광동",
    //     "phone": "052-245-8078",
    //     "date": ""
    // },
    // {
    //     "lat": "37.5345209941094",
    //     "lng": "126.988471989299",
    //     "title": "크리스피포크타운",
    //     "addr1": "서울 용산구 녹사평대로40길 47",
    //     "addr2": "1층",
    //     "sidx": "5207",
    //     "thumb": "/upload/category/20241114165341_fcf231da.png",
    //     "smidx": "11",
    //     "category": "성시경 먹을텐데",
    //     "menu": "Crispypork taco, Beef Suadero, Birria quesadilla",
    //     "phone": "0507-1483-2849",
    //     "date": ""
    // },
    {
        "lat": "37.4854923844293",
        "lng": "126.70769464585",
        "title": "산동포자",
        "addr1": "인천 부평구 마장로 75",
        "addr2": "",
        "sidx": "4151",
        "thumb": "/upload/category/20241114165426_2c796cb0.png",
        "smidx": "11",
        "category": "백종원 님아 그 시장을 가오",
        "menu": "홍소스즈토우,경장육사,해파리내채,바지락,샹라샤,가지,가지새우 등",
        "phone": "032-431-8885",
        "date": ""
    },
    {
        "lat": "37.5191210876079",
        "lng": "127.020121061287",
        "title": "신비갈비살",
        "addr1": "서울 강남구 강남대로158길 15",
        "addr2": "1층",
        "sidx": "1475",
        "thumb": "/upload/category/20241114165613_aa88a9a6.png",
        "smidx": "11",
        "category": "최자로드",
        "menu": "한우갈비반짝모듬,한우갈비살,한우갈비한짝모듬,",
        "phone": "0507-1331-5992",
        "date": ""
    },
]

export const categoryList = [
    {
        title: "place",
        info_list: [
            "백종원 님아 그 시장을 가오",
            "성시경 먹을텐데",
            "풍자 또간다",
            "먹보스 쭈엽이",
            "최자로드"
        ]
    },
]

export const addressList = [
    {
        title: "광역시도",
        info_list: [
            "서울특별시",
            "부산광역시",
            "대구광역시",
            "인천광역시",
            "광주광역시",
            "대전광역시",
            "울산광역시",
            "경기도",
            "강원특별자치도",
            "충청북도",
            "충청남도",
            "전북특별자치도",
            "전라남도",
            "경상북도",
            "경상남도",
            "제주도",
            "세종특별자치시",
        ]
    },
    {
        title: "서울특별시",
        info_list: [
            "강남구",
            "강동구",
            "강북구",
            "강서구",
            "관악구",
            "광진구",
            "구로구",
            "금천구",
            "노원구",
            "도봉구",
            "동대문구",
            "동작구",
            "마포구",
            "서대문구",
            "서초구",
            "성동구",
            "성북구",
            "송파구",
            "양천구",
            "영등포구",
            "용산구",
            "은평구",
            "종로구",
            "중구",
            "중랑구",
        ]
    },
    {
        title: "부산광역시",
        info_list: [
            "강서구",
            "금정구",
            "기장군",
            "남구",
            "동구",
            "동래구",
            "부산진구",
            "북구",
            "사상구",
            "사하구",
            "서구",
            "수영구",
            "연제구",
            "영도구",
            "중구",
            "해운대구",
        ]
    },
    {
        title: "대구광역시",
        info_list: [
            "군위군",
            "남구",
            "달서구",
            "달성군",
            "동구",
            "북구",
            "서구",
            "수성구",
            "중구",
        ]
    },
    {
        title: "인천광역시",
        info_list: [
            "강화군",
            "계양구",
            "남동구",
            "동구",
            "미추홀구",
            "부평구",
            "서구",
            "연수구",
            "옹진군",
            "중구",
        ]
    },
    {
        title: "광주광역시",
        info_list: [
            "광산구",
            "남구",
            "동구",
            "북구",
            "서구",
        ]
    },
    {
        title: "대전광역시",
        info_list: [
            "대덕구",
            "동구",
            "서구",
            "유성구",
            "중구",
        ]
    },
    {
        title: "울산광역시",
        info_list: [
            "남구",
            "동구",
            "북구",
            "울주군",
            "중구",
        ]
    },
    {
        title: "경기도",
        info_list: [
            "가평군",
            "고양시",
            "고양시 덕양구",
            "고양시 일산동구",
            "고양시 일산서구",
            "과천시",
            "광명시",
            "광주시",
            "구리시",
            "군포시",
            "김포시",
            "남양주시",
            "동두천시",
            "부천시",
            "부천시 소사구",
            "부천시 오정구",
            "부천시 원미구",
            "성남시",
            "성남시 분당구",
            "성남시 수정구",
            "성남시 중원구",
            "수원시",
            "수원시 권선구",
            "수원시 영통구",
            "수원시 장안구",
            "수원시 팔달구",
            "시흥시",
            "안산시",
            "안산시 단원구",
            "안산시 상록구",
            "안성시",
            "안양시",
            "안양시 동안구",
            "안양시 만안구",
            "양주시",
            "양평군",
            "여주시",
            "연천군",
            "오산시",
            "용인시",
            "용인시 기흥구",
            "용인시 수지구",
            "용인시 처인구",
            "의왕시",
            "의정부시",
            "이천시",
            "파주시",
            "평택시",
            "포천시",
            "하남시",
            "화성시",
        ]
    },
    {
        title: "강원특별자치도",
        info_list: [
            "강릉시",
            "고성군",
            "동해시",
            "삼척시",
            "속초시",
            "양구군",
            "양양군",
            "영월군",
            "원주시",
            "인제군",
            "정선군",
            "철원군",
            "춘천시",
            "태백시",
            "평창군",
            "홍천군",
            "화천군",
            "횡성군",
        ]
    },
    {
        title: "충청북도",
        info_list: [
            "괴산군",
            "단양군",
            "보은군",
            "영동군",
            "옥천군",
            "음성군",
            "제천시",
            "증평군",
            "진천군",
            "청원군",
            "청주시",
            "청주시 상당구",
            "청주시 흥덕구",
            "충주시",
        ]
    },
    {
        title: "충청남도",
        info_list: [
            "계룡시",
            "공주시",
            "금산군",
            "논산시",
            "당진시",
            "보령시",
            "부여군",
            "서산시",
            "서천군",
            "아산시",
            "연기군",
            "예산군",
            "천안시",
            "천안시 동남구",
            "천안시 서북구",
            "청양군",
            "태안군",
            "홍성군",
        ]
    },
    {
        title: "전북특별자치도",
        info_list: [
            "고창군",
            "군산시",
            "김제시",
            "남원시",
            "무주군",
            "부안군",
            "순창군",
            "완주군",
            "익산시",
            "임실군",
            "장수군",
            "전주시",
            "전주시 덕진구",
            "전주시 완산구",
            "정읍시",
            "진안군",
        ]
    },
    {
        title: "전라남도",
        info_list: [
            "강진군",
            "고흥군",
            "곡성군",
            "광양시",
            "구례군",
            "나주시",
            "담양군",
            "목포시",
            "무안군",
            "보성군",
            "순천시",
            "신안군",
            "여수시",
            "영광군",
            "영암군",
            "완도군",
            "장성군",
            "장흥군",
            "진도군",
            "함평군",
            "해남군",
            "화순군",
        ]
    },
    {
        title: "경상북도",
        info_list: [
            "경산시",
            "경주시",
            "고령군",
            "구미시",
            "군위군",
            "김천시",
            "문경시",
            "봉화군",
            "상주시",
            "성주군",
            "안동시",
            "영덕군",
            "영양군",
            "영주시",
            "영천시",
            "예천군",
            "울릉군",
            "울진군",
            "의성군",
            "청도군",
            "청송군",
            "칠곡군",
            "포항시",
            "포항시 남구",
            "포항시 북구",
        ]
    },
    {
        title: "경상남도",
        info_list: [
            "거제시",
            "거창군",
            "고성군",
            "김해시",
            "남해군",
            "밀양시",
            "사천시",
            "산청군",
            "양산시",
            "의령군",
            "진주시",
            "창녕군",
            "창원시",
            "창원시 마산합포",
            "창원시 마산회원",
            "창원시 성산구",
            "창원시 의창구",
            "창원시 진해구",
            "통영시",
            "하동군",
            "함안군",
            "함양군",
            "합천군",
        ]
    },
    {
        title: "제주도",
        info_list: [
            "서귀포시",
            "제주시",
        ]
    },
    {
        title: "세종특별자치시",
        info_list: [
            "세종특별자치시",
        ]
    },
]